import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

//image
import PartnerSectionImg1 from '../../assets/img/partner-section-img1.png'; //環境部
import PartnerSectionImg2 from '../../assets/img/partner-section-img2.jpg'; //交通部
import PartnerSectionImg3 from '../../assets/img/logo-nu.png'; //紐崔萊
import PartnerSectionImg4 from '../../assets/img/partner-section-img4.png'; //Sweet Protection
import PartnerSectionImg5 from '../../assets/img/partner-section-img5.png';
import PartnerSectionImg6 from '../../assets/img/partner-section-img6.png';
import PartnerSectionImg7 from '../../assets/img/partner-section-img7.png'; //名衍
import PartnerSectionImg8 from '../../assets/img/partner-section-img8.png'; //雪霸運動
import PartnerSectionImg9 from '../../assets/img/partner-section-img9.png'; //日管處
import PartnerSectionImg10 from '../../assets/img/partner-section-img10.png'; //Titan
import PartnerSectionImg11 from '../../assets/img/partner-section-img11.png'; //Bone
import PartnerSectionImg12 from '../../assets/img/partner-section-img12.png'; //南投縣政府
import PartnerSectionImg13 from '../../assets/img/partner-section-img13.png'; //推廣協會
import PartnerSectionImg14 from '../../assets/img/partner-section-img14.png'; //Oakley
import PartnerSectionImg15 from '../../assets/img/partner-section-img15.png'; //米其林
import PartnerSectionImg16 from '../../assets/img/partner-section-img16.png'; //Corima
import PartnerSpecialized from '../../assets/img/partner-specialized.jpg'; //specialized
import PartnerPNS from '../../assets/img/partner-pns.jpg'; //png
import PartnerViva from '../../assets/img/partner-viva.jpg'; //viva
import PartnerDrWang from '../../assets/img/partner-drwang.jpg'; //drwang
import PartnerSectionImg17 from '../../assets/img/partner-section-department-of-sport.png'; //運動部
import PartnerLooking from '../../assets/img/partner-looking.png'; //Looking
import PartnerJzn from '../../assets/img/partner-jzn.png'; //舊振南
import PartnerDazn from '../../assets/img/partner-DAZN.png'; //DAZN
import PartnerGreenpoint from '../../assets/img/partner-GREENPOINT.png'; //Greenpoint
import PartnerFoxtron from '../../assets/img/partner-FOXTRON.png'; //FOXTRON
import PartnerPortCompany from '../../assets/img/partner-port-company.png'; //台灣港務公司
import PartnerYufong from '../../assets/img/partner-yufong.png'; //御奉
import PartnerIntothewildshop from '../../assets/img/partner-intothewildshop.png'; //山研所
import PartnerShimano from '../../assets/img/partner-SHIMANO.png'; //SHIMANO
import PartnerTissot from '../../assets/img/partner-TISSOT.png'; //天梭






const PartnerSection = ({language}) => {
    return (
        <section className="partner-section">
            <Container>
                <Row className='align-items-center text-center py-2'>
                    {
                        language === "Chinese" ? <h1><span>合作夥伴</span></h1> : <h1><span>OFFICIAL PARTNERS</span></h1>
                    }
                </Row>
                <Row className='align-items-center text-center my-4'>
                    <h2>指導單位 | Advisory Organizations</h2>
                    <Col size={12} xs={6} md={6} sm={6} >
                        <a href="https://www.sports.gov.tw/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-100' src={PartnerSectionImg17} alt="運動部 Ministry of Sports" />
                            </div>
                        </a>
                    </Col>
                    <Col  size={12} xs={6} md={6} sm={6}>
                        <a href="https://www.taiwan.net.tw/w1.aspx" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-100' src={PartnerSectionImg2} alt="交通部觀光署 Tourism Administration, MOTC" />
                            </div>
                        </a>
                    </Col>
                    <Col size={12} xs={6} md={6} sm={6} >
                        <a href="https://www.nantou.gov.tw/big5/index.php" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img src={PartnerSectionImg12} alt="南投縣政府 Nantou County Government" />
                            </div>
                        </a>
                    </Col>
                    <Col size={12} xs={6} md={6} sm={6} >
                        <a href="https://www.aso.fr/en/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-100' src={PartnerSectionImg5} alt="A.S.O." />
                            </div>
                        </a>
                    </Col>
                </Row>
                <Row className='align-items-center text-center my-4'>
                    <h2>冠名贊助 | Title Sponsor</h2>
                    <Col xs={12} className='center'>
                        <a href="https://www.nutrilite.com.tw/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-100 my-5 logo-nu' src={PartnerSectionImg3} alt="紐崔萊 Nutrilite" />
                            </div>
                        </a>
                    </Col>
                </Row>
                <Row className='align-items-center text-center my-4'>
                    <h2>主辦單位 | Organizers</h2>
                    <Col xs={6}>
                        <div className="img-bx">
                            <img src={PartnerSectionImg13} alt="" />
                        </div>
                    </Col>
                    <Col xs={6}>
                        <a href="https://body-marketing.com.tw/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img src={PartnerSectionImg7} alt="" />
                            </div>
                        </a>
                    </Col>
                </Row>
                <Row className='align-items-center text-center my-4' rel='noreferrer noopener'>
                    <h2>環法官方計時 | Official Timekeeper</h2>
                    <Col xs={12}>
                        <a href="https://www.tissotwatches.com/zht-tw" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img src={PartnerTissot} alt="TISSOT" />
                            </div>
                        </a>
                    </Col>
                </Row>
                <Row className='align-items-center text-center my-4' rel='noreferrer noopener'>
                    <h2>協辦單位 | Co-organizer</h2>
                    <Col xs={6}>
                        <a href="https://admin.taiwan.net.tw/sunmoonlake/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img src={PartnerSectionImg9} alt="交通部觀光署日月潭國家風景區管理處 Sun Moon Lake National Scenic Area Administration" />
                            </div>
                        </a>
                    </Col>
                </Row>
                <Row className='align-items-center text-center my-4'>
                    <h2>合作夥伴 | Official Partners</h2>
                    {/* Specialized */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.specialized.com/tw/zh" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerSpecialized} alt="Specialized" />
                            </div>
                        </a>
                    </Col>
                    {/* <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.sweetprotection.com/?srsltid=AfmBOorAMkZzL7xqUTQuhhhAVvDJRKl0gE7fFFyP_kepC7eBRo7ZNSl8" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                            <img className='w-75' src={PartnerSectionImg4} alt="" />
                            </div>
                        </a>
                    </Col> */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.titan-tech.com.tw/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerSectionImg10} alt="Titan" />
                            </div>
                        </a>
                    </Col>
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.boneshop.com/tw/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerSectionImg11} alt="BONE" />
                            </div>
                        </a>
                    </Col>
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://tw.oakley.com/zh" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerSectionImg14} alt="Oakley" />
                            </div>
                        </a>
                    </Col>
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.mommyhappy.com/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerSectionImg6} alt="" />
                            </div>
                        </a>
                    </Col>
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://guide.michelin.com/tw/zh_TW" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerSectionImg15} alt="Michelin Guide" />
                            </div>
                        </a>
                    </Col>
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.corima.com/home.html" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerSectionImg16} alt="Corima" />
                            </div>
                        </a>
                    </Col>
                    
                    {/* PNS
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.stand-collection.com/v2/official/SalePageCategory/281008?srsltid=AfmBOorFSo8GpRLcokgxaR8GTjA9ZxZbsfq1bHEqOtxNZ4156a-iuUvy&sortMode=Newest" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerPNS} alt="" />
                            </div>
                        </a>
                    </Col> */}
                    {/* 萬歲 */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <div >
                            <div className="img-bx">
                                <img className='w-75' src={PartnerViva} alt="" />
                            </div>
                        </div>
                    </Col>
                    {/* 王大夫 */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <div>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerDrWang} alt="" />
                            </div>
                        </div>
                    </Col>
                    {/* looking */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://zh-tw.lookingtaiwan.com/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerLooking} alt="Looking" />
                            </div>
                        </a>
                    </Col>
                    {/* 舊振南 */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.jzn.com.tw/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerJzn} alt="舊振南 Jiu Zhen Nan" />
                            </div>
                        </a>
                    </Col>
                    {/* DAZN */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.dazn.com/zh-TW/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerDazn} alt="DAZN" />
                            </div>
                        </a>
                    </Col>
                    {/* Greenpoint */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.greenpoint.org.tw/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerGreenpoint} alt="Greenpoint" />
                            </div>
                        </a>
                    </Col>
                    {/* Foxtron */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.foxtronev.com/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerFoxtron} alt="Foxtron" />
                            </div>
                        </a>
                    </Col>
                    {/* 台灣港務公司 */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.twport.com.tw/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerPortCompany} alt="台灣港務公司 Taiwan International Ports Corporation" />
                            </div>
                        </a>
                    </Col>
                    {/* 山研所 */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://intothewildshop.tw/" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerIntothewildshop} alt="" />
                            </div>
                        </a>
                    </Col>
                    {/* 玉鳳 */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://www.emperorlove.com/?srsltid=AfmBOorNFmtuMqUd0Q-MmKJx-RPzaVJME4rjkVxxj6yqwL1j8bdARVz7" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerYufong} alt="" />
                            </div>
                        </a>
                    </Col>
                    {/* SHINAMO */}
                    <Col size={12} xs={6} md={3} sm={6} className='py-4'>
                        <a href="https://bike.shimano.com/zh-TW/home.html" target='_blank' rel='noreferrer noopener'>
                            <div className="img-bx">
                                <img className='w-75' src={PartnerShimano} alt="SHIMANO" />
                            </div>
                        </a>
                    </Col>

                </Row>
            </Container>
        </section>
    )
}

export default PartnerSection